import React, {Component} from "react";
import lockIcon from "../../assets/24_lock_white.svg"
import { CircleQuestionMark } from "lucide-react";
import { ICON_SIZE } from "components/common/constants";
import {Tag, TagType} from "components/common/Tag.component";
import { Tooltip } from "components/tooltip/Tooltip";

export class ApprovalStep4EyesHeader extends Component {

    render() {
        let {toggle, collapsed} = this.props;
        let toggleIconClass = "glyphicon font-18 margin-right glyphicon-menu-" + (collapsed ? "right" : "down");

        return (
            <div className="d-flex pr-0 justify-content-between align-items-center w-100">
                <span className="d-flex align-items-center">
                    <span className={toggleIconClass} onClick={toggle}/>
                    <span className="d-flex gap-8 align-items-center">
                        <span>
                            <strong className="step-header">{this.props.translate("workflowDetails.4EyesApproval.header")}</strong>
                        </span>
                        <span className="d-flex text-white"
                              data-for="four-eyes-header-info-tooltip" data-tip="">
                            <CircleQuestionMark size={ICON_SIZE.SMALL}/>
                        </span>
                        <Tooltip
                            id="four-eyes-header-info-tooltip"
                            content={() => this.props.translate("workflowDetails.4EyesApproval.headerInfo")}
                        />
                        {this.props.hasInvalidApprovers && <Tag type={TagType.WARNING} message={this.props.translate("workflows.invalidApprovers")} />}
                    </span>
                </span>
                <img src={lockIcon}
                     alt="lock icon"
                     width="16"/>
            </div>
        )

    }
}
